export const emitterInjectKey = 'emitter'
